module.exports = __webpack_public_path__ + "static/img/color.2aaaf75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/color.png
// module id = 92Oy
// module chunks = 174